module.exports = __webpack_public_path__ + "assets/images/project/icons/cursor_360.svg?v=5d2aef12";